import type {
  Session,
  OptionalCustomerSession,
  OptionalCustomerSession_NoSession,
  AnySession,
  AnySession_NoSession,
  CustomerSession,
  GuestSession,
} from "../../aysa_api/models/session.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseSession = (): Session => {
  return {};
};

export const decodeSession = (reader: Reader, length: number): Session => {
  const end = reader.pos + length;
  const message = createBaseSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = {
          $case: "customer",
          customer: decodeCustomerSession(reader, reader.uint32()),
        };

        break;
      case 2:
        message.type = {
          $case: "guest",
          guest: decodeGuestSession(reader, reader.uint32()),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSession = (writer: Writer, message: Session): Writer => {
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "customer":
        encodeCustomerSession(
          writer.uint32(10).fork(),
          message.type.customer
        ).ldelim();

        break;
      case "guest":
        encodeGuestSession(
          writer.uint32(18).fork(),
          message.type.guest
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseOptionalCustomerSession =
  (): OptionalCustomerSession => {
    return {};
  };

export const decodeOptionalCustomerSession = (
  reader: Reader,
  length: number
): OptionalCustomerSession => {
  const end = reader.pos + length;
  const message = createBaseOptionalCustomerSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = {
          $case: "customer",
          customer: decodeCustomerSession(reader, reader.uint32()),
        };

        break;
      case 2:
        message.type = {
          $case: "noSession",
          noSession: decodeOptionalCustomerSession_NoSession(
            reader,
            reader.uint32()
          ),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeOptionalCustomerSession = (
  writer: Writer,
  message: OptionalCustomerSession
): Writer => {
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "customer":
        encodeCustomerSession(
          writer.uint32(10).fork(),
          message.type.customer
        ).ldelim();

        break;
      case "noSession":
        encodeOptionalCustomerSession_NoSession(
          writer.uint32(18).fork(),
          message.type.noSession
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseOptionalCustomerSession_NoSession =
  (): OptionalCustomerSession_NoSession => {
    return {};
  };

export const decodeOptionalCustomerSession_NoSession = (
  reader: Reader,
  length: number
): OptionalCustomerSession_NoSession => {
  const end = reader.pos + length;
  const message = createBaseOptionalCustomerSession_NoSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeOptionalCustomerSession_NoSession = (
  writer: Writer,
  _message: OptionalCustomerSession_NoSession
): Writer => {
  return writer;
};

export const createBaseAnySession = (): AnySession => {
  return {};
};

export const decodeAnySession = (
  reader: Reader,
  length: number
): AnySession => {
  const end = reader.pos + length;
  const message = createBaseAnySession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = {
          $case: "customer",
          customer: decodeCustomerSession(reader, reader.uint32()),
        };

        break;
      case 2:
        message.type = {
          $case: "noSession",
          noSession: decodeAnySession_NoSession(reader, reader.uint32()),
        };

        break;
      case 3:
        message.type = {
          $case: "guest",
          guest: decodeGuestSession(reader, reader.uint32()),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeAnySession = (
  writer: Writer,
  message: AnySession
): Writer => {
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "customer":
        encodeCustomerSession(
          writer.uint32(10).fork(),
          message.type.customer
        ).ldelim();

        break;
      case "noSession":
        encodeAnySession_NoSession(
          writer.uint32(18).fork(),
          message.type.noSession
        ).ldelim();

        break;
      case "guest":
        encodeGuestSession(
          writer.uint32(26).fork(),
          message.type.guest
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseAnySession_NoSession = (): AnySession_NoSession => {
  return {};
};

export const decodeAnySession_NoSession = (
  reader: Reader,
  length: number
): AnySession_NoSession => {
  const end = reader.pos + length;
  const message = createBaseAnySession_NoSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeAnySession_NoSession = (
  writer: Writer,
  _message: AnySession_NoSession
): Writer => {
  return writer;
};

export const createBaseCustomerSession = (): CustomerSession => {
  return {
    authToken: "",
  };
};

export const decodeCustomerSession = (
  reader: Reader,
  length: number
): CustomerSession => {
  const end = reader.pos + length;
  const message = createBaseCustomerSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.authToken = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeCustomerSession = (
  writer: Writer,
  message: CustomerSession
): Writer => {
  writer.uint32(10).string(message.authToken);

  return writer;
};

export const createBaseGuestSession = (): GuestSession => {
  return {
    sessionId: "",
  };
};

export const decodeGuestSession = (
  reader: Reader,
  length: number
): GuestSession => {
  const end = reader.pos + length;
  const message = createBaseGuestSession();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.sessionId = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeGuestSession = (
  writer: Writer,
  message: GuestSession
): Writer => {
  writer.uint32(10).string(message.sessionId);

  return writer;
};
